export default __webpack_public_path__ + "static/media/bookRed.ea7ad92b.svg";